import {SelectPickerDialog} from './components/SelectPickerDialog'
import {useReposItemConfig} from './hooks/ItemConfig'
import type {CommonDialogProps, SingleSelectReposProps} from './types'

type SingleSelectReposPickerDialogProps = SingleSelectReposProps & CommonDialogProps

export function SingleSelectReposPickerDialog({scope, ...props}: SingleSelectReposPickerDialogProps) {
  const itemConfig = useReposItemConfig(scope)
  const arraySelected = props.selected ? [props.selected] : []
  return (
    <SelectPickerDialog
      {...props}
      title="Select a repository"
      selectionVariant="single"
      selected={arraySelected}
      onSubmit={items => props.onSubmit(items[0])}
      itemConfig={itemConfig}
    />
  )
}

try{ SingleSelectReposPickerDialog.displayName ||= 'SingleSelectReposPickerDialog' } catch {}